import ReservationHistories                 from "../../../../domain/reservation/history/ReservationHistories";
import ReservationHistory                   from "../../../../domain/reservation/history/ReservationHistory";
import { ReservationHistoriesResponseType } from "../../../api/reservation/history/ReservationHistoriesResponseType";
import { ReservationHistoryResponseType }   from "../../../api/reservation/history/ReservationHistoryResponseType";
import { toPlan }                           from "../../plan";
import { toReservation }                    from "../index";

export const toReservationHistory = (source: ReservationHistoryResponseType): ReservationHistory => new ReservationHistory(
  toReservation(source.reservation),
  toPlan(source.plan),
);

export const toReservationHistories = (source: ReservationHistoriesResponseType): ReservationHistories => new ReservationHistories(
  source.histories.map(value => toReservationHistory(value))
);
